export default {"src":"/_next/static/media/ArrowRight.88ed9bd9.svg","height":20,"width":21,"blurWidth":0,"blurHeight":0};